<!-- Filtro -->
<div *ngIf="isFilterable" class="filter">
  <!-- <div class="container-filter">
    <label class="lbl-filtro">Filtrar resultados</label>
    <input
      class="form-control custom-form-group filter txt-filtro"
      #filterRef
      [formControl]="filterControl"
      (keyup)="applyFilter()"
      type="text"
      [placeholder]="searchText"
    />
    <span
      class="material-symbols-outlined"
      *ngIf="!!filterControl.value"
      (click)="clearFilter()"
      >close</span
    >
  </div> -->

  <ids-input-search (cleared)="clearFilter()">
    <input
      idsInput
      name="Filtrar resultados"
      type="text"
      [(ngModel)]="filterValue"
      (ngModelChange)="applyFilter()"
      [placeholder]="searchText"
    />
  </ids-input-search>
</div>

<!-- Tabela -->
<table
  [class]="privateCss"
  mat-table
  [dataSource]="dataSource"
  matSort
  multiTemplateDataRows
>
  <ng-container
    [matColumnDef]="tableData"
    *ngFor="let tableData of objectKeys(columnsHeader)"
  >
    <!-- Cabeçalhos da tabela -->
    <ng-container *ngIf="columnsHeader[tableData] !== 'select'">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [ngClass]="{
          'data-table__th': tableOperationCase,
          'data-table__td-table': tableOperationCase,
          'data-table__th-account-operation-case': accountOperationCase,
        }"
      >
        {{ columnsHeader[tableData] }}
      </th>
    </ng-container>

    <!-- Cabeçalho com checkbox -->
    <ng-container *ngIf="columnsHeader[tableData] === 'select'">
      <th
        mat-header-cell
        *matHeaderCellDef
        [ngClass]="{ 'data-table__th-checkbox': tableOperationCase }"
      >
        <mat-checkbox
          id="allItemsCheckBox"
          #allItemsCheckBox
          (change)="$event ? masterToggle($event) : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
          [aria-label]="checkboxLabel()"
          (indeterminateChange)="indeterminateChange($event)"
        >
        </mat-checkbox>
      </th>
    </ng-container>

    <!-- Células da tabela -->
    <ng-container
      *ngIf="
        columnsHeader[tableData] !== 'select' &&
        columnsHeader[tableData] !== configAction?.columnDisplayName
      "
    >
      <!-- Tooltip aplicado para:
      Telas menores -> (characterLimit) caracteres
      telas maiores -> 50 caracteres (espaço máximo) -->
      <td
        mat-cell
        *matCellDef="let element"
        [matTooltip]="
          (tableOperationCase && element[tableData]?.length > characterLimit) ||
          (!tableOperationCase && element[tableData]?.length > 50)
            ? element[tableData]
            : ''
        "
        [ngClass]="{
          'data-table__td-table': tableOperationCase,
          'data-table__td-account-operation-case': accountOperationCase,
        }"
      >
        <div [ngClass]="element[tableData]">
          {{
            tableOperationCase
              ? formatLengthTableData(element[tableData])
              : element[tableData]
          }}
        </div>
      </td>
    </ng-container>

    <!-- Célula com checkbox  -->
    <ng-container *ngIf="columnsHeader[tableData] === 'select'">
      <td
        mat-cell
        *matCellDef="let row"
        [ngClass]="{ 'data-table__td-checkbox': tableOperationCase }"
      >
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selectItem(row) : null"
          [checked]="selection.isSelected(row)"
          [aria-label]="checkboxLabel(row)"
        >
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- Células da tabela com ação -->
    <ng-container
      *ngIf="columnsHeader[tableData] === configAction?.columnDisplayName"
    >
      <td
        mat-cell
        *matCellDef="let element"
        class="action-cell"
        [ngClass]="{ 'data-table__td-action': tableOperationCase }"
      >
        <div class="d-flex flex-row row-actions" [ngStyle]="configAction.style">
          <!-- Name -->
          <div
            *ngIf="configAction?.rowDisplayName !== null"
            class="action action-icon"
            (click)="emitAction(element, $event)"
          >
            <ids-icon
              idsTooltip="description"
              [content]="getRowDisplayName(element)"
              variant="primary"
              >{{ configAction?.rowDisplayNameIcon }}</ids-icon
            >
          </div>

          <!-- View -->
          <div
            *ngIf="
              !configAction?.rowDisplayIconViewShow ||
              configAction?.rowDisplayIconViewShow(element)
            "
            class="action-icon"
            (click)="emitActionView(element, $event)"
          >
            <ids-icon
              [ngClass]="{
                'data-table__view-icon-disabled':
                  accountOperationCase &&
                  (tableDataLength === 1 || element?.quantidadeContas === 0),
              }"
              idsTooltip="description"
              [content]="
                getContentAccountOperationCase(element) ||
                configAction?.rowDisplayIconViewText
              "
              variant="primary"
              class="icon-acao view"
            >
              {{ configAction?.rowDisplayIconView || 'informacao_outline' }}
            </ids-icon>
          </div>

          <!-- Edit -->
          <div
            *ngIf="
              !configAction?.rowDisplayIconEditShow ||
              configAction?.rowDisplayIconEditShow(element)
            "
            class="action-icon action-edit"
            (click)="emitActionEdit(element, $event)"
          >
            <ids-icon
              idsTooltip="description"
              [content]="configAction?.rowDisplayIconEditText"
              class="icon-acao"
              variant="primary"
            >
              {{ configAction?.rowDisplayIconEdit || 'editar_outline' }}
            </ids-icon>
          </div>

          <!-- Delete -->
          <div
            *ngIf="
              !configAction?.rowDisplayIconDeleteShow ||
              configAction?.rowDisplayIconDeleteShow(element)
            "
            class="action-icon action-delete"
            (click)="emitActionDelete(element, $event)"
          >
            <ids-icon
              idsTooltip="description"
              [content]="configAction?.rowDisplayIconDeleteText"
              class="icon-acao"
              variant="primary"
              >{{
                configAction?.rowDisplayIconDelete || 'excluir_outline'
              }}</ids-icon
            >
          </div>
          <!-- Open Context Menu -->
          <div
            *ngIf="configAction?.rowDisplayIconMenuShow"
            class="action-icon action-menu"
            [matMenuTriggerFor]="matMenu"
            [matTooltip]="rotateActionIcon ? tooltipActionIcon : ''"
          >
            <ids-icon
              class="icon-acao"
              [ngClass]="{ 'rotate-90': rotateActionIcon }"
              variant="primary"
              >{{ configAction?.rowDisplayIconMenu || 'outros' }}</ids-icon
            >
          </div>
          <!-- Menu de ações -->
          <mat-menu #matMenu="matMenu">
            <ng-container
              *ngFor="let menuItem of configAction?.rowDisplayIconMenuItems"
            >
              <button
                mat-menu-item
                (click)="
                  emitActionOpenMenu(
                    element,
                    menuItem.action,
                    menuItem.disabled,
                    $event
                  )
                "
                class="d-flex align-items-center gap-2"
                [disabled]="menuItem.disabled"
              >
                <ids-icon variant="primary">{{ menuItem.icon }}</ids-icon>
                <span>{{ menuItem.label }}</span>
              </button>
            </ng-container>
          </mat-menu>
        </div>
      </td>
    </ng-container>
  </ng-container>

  <!-- detalhes da tabela -->
  <ng-container *ngIf="hasDetailRenderer">
    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let row"
        [attr.colspan]="objectKeys(columnsHeader).length"
      >
        <div
          class="element-detail"
          [@detailExpand]="row === expandedElement ? 'expanded' : 'collapsed'"
        >
          <div *ngIf="row === expandedElement">
            <ng-content select="[table-detail]"></ng-content>
          </div>
        </div>
      </td>
    </ng-container>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="objectKeys(columnsHeader)"></tr>
  <tr
    mat-row
    *matRowDef="let row; let i = index; columns: objectKeys(columnsHeader)"
    [ngClass]="{
      'element-row': hasDetailRenderer,
    }"
    [class]="getRowClass(row)"
    [class.expanded-row]="expandedElement === row"
    (click)="rowClick(row)"
  ></tr>

  <!-- Row com os detalhes da tabela -->
  <ng-container *ngIf="hasDetailRenderer">
    <tr
      mat-row
      *matRowDef="let row; columns: ['expandedDetail']"
      class="detail-row"
    ></tr>
  </ng-container>
</table>

<!-- Paginação e Mensagem de apoio (caso tenha) -->
<div
  class="d-flex align-items-center justify-content-end"
  [ngClass]="{
    'data-table__paginator-account-operation-case': accountOperationCase,
  }"
>
  <mat-paginator
    [pageSizeOptions]="paginationSizes"
    [pageSize]="defaultPageSize"
    showFirstLastButtons
    (page)="onPageChange($event)"
  >
  </mat-paginator>
</div>
